import * as React from 'react';
import { EditIcon, EntityCard } from '@ui/components';

import './ManagerCard.less';
import { Modal, notification } from 'antd';
import { removeManager } from '@ui/api/v2/user.api';

interface Props {
  manager: any;
  onRemoveManager: (managerId: number) => void;
  onEdit: (manager: any) => void;
}

class ManagerCard extends React.PureComponent<Props> {
  state = {
    isOpenRemove: false,
  };

  handleChangeRemoveState = (isOpenRemove: boolean) => {
    this.setState({ isOpenRemove });
  };

  handleRemoveManager = async () => {
    const {
      manager: { id },
      onRemoveManager,
    } = this.props;

    this.handleChangeRemoveState(false);
    const { error } = await removeManager(id);
    if (error) {
      notification.error({
        message: error.response.data.message,
      });
    } else {
      onRemoveManager(id);
    }
  };

  render() {
    const { manager, onEdit } = this.props;

    const { isOpenRemove } = this.state;

    return (
      <EntityCard>
        <div className="manager-card">
          <div className="manager-card-name">
            <span>{manager.login}</span>
          </div>
          <div className="manager-card-regions">
            {manager.regions.map((region: any) => (
              <span key={region.id}>{region.name} обл.</span>
            ))}
          </div>
          <div className="manager-card-edit">
            <EditIcon type="edit" onClick={() => onEdit(manager)} />
            <EditIcon type="remove" onClick={() => this.handleChangeRemoveState(true)} />
          </div>
          <Modal
            okButtonProps={{
              style: {
                width: '120px',
              },
              size: 'large',
              type: 'danger',
            }}
            cancelButtonProps={{
              style: {
                width: '120px',
              },
              size: 'large',
              type: 'primary',
            }}
            okText="Да"
            cancelText="Нет"
            title="удаление менеджера"
            visible={isOpenRemove}
            onOk={this.handleRemoveManager}
            onCancel={() => this.handleChangeRemoveState(false)}
          >
            <p>Вы уверены, что ходите удалить?</p>
            <p>Менеджера</p>
            <p style={{ fontSize: '16px' }}>{name}</p>
          </Modal>
        </div>
      </EntityCard>
    );
  }
}

export default ManagerCard;



// WEBPACK FOOTER //
// ./src/scenes/Managers/components/ManagerCard/ManagerCard.tsx